import React, { useState } from "react";
import { Result, Button, Row, Col, message } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const ActivationPrompt = () => {
  const navigate = useNavigate();
  const [resendLoading, setResendLoading] = useState(false);

  const handleResend = async () => {
    try {
      setResendLoading(true);
      const email = localStorage.getItem("emailForActivation");
      await axios.post("/api/accounts/resend_activation_email/", {
        email,
      });
      message.success("Activation email sent successfully");
    } catch (error) {
      message.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <Row justify="center" style={{ marginTop: 100 }}>
      <Col xs={24} sm={18} md={12} lg={10}>
        <div style={{ padding: 24, background: "#fff", borderRadius: 4 }}>
          <Result
            icon={
              <MailOutlined style={{ color: "#1890ff", fontSize: "72px" }} />
            }
            title="Activation Email Sent"
            subTitle={
              <div style={{ fontSize: "16px" }}>
                <p>We have sent an activation link to your registered email</p>
                <p>
                  Please click the link in the email to complete account
                  activation
                </p>
                <p style={{ color: "#666", marginTop: "12px" }}>
                  (If you don't see the email, please check your spam folder)
                </p>
              </div>
            }
            extra={[
              <Button
                type="primary"
                key="return"
                onClick={() => navigate("/login/", { replace: true })}
              >
                Login
              </Button>,
              <Button
                key="resend"
                loading={resendLoading}
                onClick={handleResend}
              >
                Not received the email? Resend Email
              </Button>,
            ]}
          />
        </div>
      </Col>
    </Row>
  );
};

export default ActivationPrompt;
